// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_JSON from "@rescript/runtime/lib/es6/Stdlib_JSON.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function decodeDict(v) {
  return Stdlib_JSON.Decode.object(v);
}

function decodeString(v) {
  return Stdlib_JSON.Decode.string(v);
}

function decodeArray(v) {
  return Stdlib_JSON.Decode.array(v);
}

function decodeBoolean(v) {
  return Stdlib_JSON.Decode.bool(v);
}

function decodeNumber(v) {
  return Stdlib_JSON.Decode.float(v);
}

function decodeNull(v) {
  return Stdlib_JSON.Decode.$$null(v);
}

function parseExn(v) {
  return JSON.parse(v);
}

function stringify(v) {
  return JSON.stringify(v);
}

function stringifyAny(v) {
  return JSON.stringify(v);
}

function decodeDictOptionalField(dict, name, decode) {
  return Stdlib_Option.flatMap(dict[name], decode);
}

function decodeDictFieldExn(dict, name, decode) {
  return Stdlib_Option.getOrThrow(decodeDictOptionalField(dict, name, decode), undefined);
}

function flatDecodeDictField(dict, name, decode) {
  return Stdlib_Option.flatMap(Stdlib_Option.flatMap(dict, dict => dict[name]), decode);
}

function flatDecodeDictFieldBoolean(dict, name) {
  return flatDecodeDictField(dict, name, decodeBoolean);
}

function flatDecodeDictFieldString(dict, name) {
  return flatDecodeDictField(dict, name, decodeString);
}

function flatDecodeDictFieldFloat(dict, name) {
  return flatDecodeDictField(dict, name, decodeNumber);
}

function flatDecodeDictFieldDict(dict, name) {
  return flatDecodeDictField(dict, name, decodeDict);
}

function flatDecodeDictFieldArray(dict, name) {
  return flatDecodeDictField(dict, name, decodeArray);
}

function decodeDictField(dict, name, decode) {
  return Stdlib_Option.flatMap(dict[name], decode);
}

function decodeDictFieldBoolean(dict, name) {
  return decodeDictField(dict, name, decodeBoolean);
}

function decodeDictFieldString(dict, name) {
  return decodeDictField(dict, name, decodeString);
}

function decodeDictFieldFloat(dict, name) {
  return decodeDictField(dict, name, decodeNumber);
}

function decodeDictFieldArray(dict, name) {
  return decodeDictField(dict, name, decodeArray);
}

function encodeArray(v) {
  return v;
}

function encodeString(v) {
  return v;
}

function encodeDict(v) {
  return v;
}

function encodeBoolean(v) {
  return v;
}

function encodeNumber(v) {
  return v;
}

function fromObjExn(obj) {
  return JSON.parse(Stdlib_Option.getOrThrow(JSON.stringify(obj), undefined));
}

function render(data) {
  return Stdlib_Option.getOr(JSON.stringify(data), "—");
}

let encodedNull = null;

export {
  decodeDict,
  decodeString,
  decodeArray,
  decodeBoolean,
  decodeNumber,
  decodeNull,
  parseExn,
  stringify,
  stringifyAny,
  decodeDictOptionalField,
  decodeDictFieldExn,
  flatDecodeDictField,
  flatDecodeDictFieldBoolean,
  flatDecodeDictFieldString,
  flatDecodeDictFieldFloat,
  flatDecodeDictFieldDict,
  flatDecodeDictFieldArray,
  decodeDictField,
  decodeDictFieldBoolean,
  decodeDictFieldString,
  decodeDictFieldFloat,
  decodeDictFieldArray,
  encodeArray,
  encodeString,
  encodeDict,
  encodeBoolean,
  encodedNull,
  encodeNumber,
  fromObjExn,
  render,
}
/* No side effect */
